// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".k_zy6Pyo{padding:20px;width:100%}\n", "",{"version":3,"sources":["webpack://./src/courses/courseEditor.scss"],"names":[],"mappings":"AAAA,UACE,YAAa,CACb,UAAW","sourcesContent":[".courseEditor {\n  padding: 20px;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"courseEditor": "k_zy6Pyo"
};
export default ___CSS_LOADER_EXPORT___;
